// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::accAnnounceMovedKey:::Moved ' +
    p['itemKey'] +
    ' ' +
    p['position'] +
    ' ' +
    p['referenceKey'] +
    '.]]',
  accButtonProgressComplete: (p: { label: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::accButtonProgressComplete:::' +
    p['label'] +
    ' action completed]]',
  accButtonProgressStatus: (p: { label: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::accButtonProgressStatus:::' +
    p['label'] +
    ' action in progress]]',
  accColorPalette: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::accColorPalette:::Color Palette]]',
  accColorSwatch: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::accColorSwatch:::Color Swatch]]',
  accCommandKey: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::accCommandKey:::Command]]',
  accContextMenuLabel: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::accContextMenuLabel:::actions]]',
  accControlKey: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::accControlKey:::Close]]',
  accPositionAfter: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::accPositionAfter:::after]]',
  accPositionBefore: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::accPositionBefore:::before]]',
  accReorderInstructions: (p: { keyPressed: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::accReorderInstructions:::Press and hold ' +
    p['keyPressed'] +
    ' and shift keys, then use the arrow keys to reorder.]]',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::calendarDateConverter_parseError:::Enter a complete date like this: ' +
    p['dateExample'] +
    '.]]',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::calendarMonthConverter_parseError:::Enter a month and year like this: ' +
    p['dateExample'] +
    '.]]',
  chart_labelDataLabel: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::chart_labelDataLabel:::Label]]',
  chart_labelGroup: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::chart_labelGroup:::Group]]',
  chart_labelSeries: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::chart_labelSeries:::Series]]',
  chart_labelValue: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::chart_labelValue:::Value]]',
  chart_labelWidthWeight: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::chart_labelWidthWeight:::Z]]',
  chart_labelX: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::chart_labelX:::X]]',
  chart_labelY: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::chart_labelY:::Y]]',
  checkboxSet_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::checkboxSet_requiredMessageDetail:::Select a value.]]',
  checkbox_helpForCheckbox: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::checkbox_helpForCheckbox:::Help for checkbox]]',
  checkbox_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::checkbox_requiredMessageDetail:::Select a value.]]',
  checkbox_selected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::checkbox_selected:::Checkbox checked]]',
  checkbox_unselected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::checkbox_unselected:::Checkbox not checked]]',
  close: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::close:::Close]]',
  collection_apply: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_apply:::Apply]]',
  collection_cancel: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_cancel:::Cancel]]',
  collection_loaded: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_loaded:::Loaded]]',
  collection_loading: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_loading:::Loading]]',
  collection_noData: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_noData:::No data to display.]]',
  collection_pixels: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_pixels:::px]]',
  collection_resizeColumnDialog: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_resizeColumnDialog:::Resize column]]',
  collection_resizeColumnMenu: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_resizeColumnMenu:::Resize Column...]]',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_resizeMessageDetail:::Enter a number between ' +
    p['MIN'] +
    ' and ' +
    p['MAX'] +
    '.]]',
  collection_selectAllRows: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_selectAllRows:::Select all rows]]',
  collection_selectRow: (p: { ROW_NAME: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_selectRow:::Select row ' +
    p['ROW_NAME'] +
    ']]',
  collection_sortAscendingSubMenu: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_sortAscendingSubMenu:::Ascending]]',
  collection_sortColumnMenu: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_sortColumnMenu:::Sort Column]]',
  collection_sortDescendingSubMenu: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_sortDescendingSubMenu:::Descending]]',
  collection_sortDisabled: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_sortDisabled:::Not sortable]]',
  collection_sortEnabled: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_sortEnabled:::Sortable]]',
  collection_width: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::collection_width:::Width]]',
  colorPicker_label: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::colorPicker_label:::Color Picker]]',
  confirmation: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::confirmation:::Confirmation]]',
  datePicker_currentDate: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_currentDate:::Current date]]',
  datePicker_goToToday: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_goToToday:::Go to today]]',
  datePicker_label: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_label:::Date Picker]]',
  datePicker_month: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_month:::Month]]',
  datePicker_months: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_months:::Months]]',
  datePicker_next: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_next:::Next]]',
  datePicker_nextDecade: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_nextDecade:::Next decade]]',
  datePicker_nextMonth: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_nextMonth:::Next month]]',
  datePicker_prev: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_prev:::Previous]]',
  datePicker_prevDecade: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_prevDecade:::Previous decade]]',
  datePicker_prevMonth: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_prevMonth:::Previous month]]',
  datePicker_restricted: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_restricted:::Restricted]]',
  datePicker_selected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_selected:::Selected]]',
  datePicker_today: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_today:::Today]]',
  datePicker_weekNum: (p: { NUM: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_weekNum:::Week ' +
    p['NUM'] +
    ']]',
  datePicker_weekNumColLabel: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_weekNumColLabel:::Week Number]]',
  datePicker_year: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_year:::Year]]',
  datePicker_years: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::datePicker_years:::Years]]',
  diagram_promotedLink: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::diagram_promotedLink:::1 link]]',
  diagram_promotedLinkAriaDesc: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::diagram_promotedLinkAriaDesc:::Indirect]]',
  diagram_promotedLinks: (p: { num_links: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::diagram_promotedLinks:::' +
    p['num_links'] +
    ' links]]',
  error: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::error:::Error]]',
  expandableList_expandCollapseInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::expandableList_expandCollapseInstructionText:::Use arrow keys to expand and collapse]]',
  expandableList_groupCollapse: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::expandableList_groupCollapse:::Collapsed]]',
  expandableList_groupExpand: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::expandableList_groupExpand:::Expanded]]',
  filePicker_addFiles: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_addFiles:::Add Files]]',
  filePicker_dropzonePrimaryText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_dropzonePrimaryText:::Drag and Drop]]',
  filePicker_dropzoneSecondaryText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_dropzoneSecondaryText:::Select a file or drop one here]]',
  filePicker_dropzoneSecondaryTextMultiple: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_dropzoneSecondaryTextMultiple:::Select or drop files here]]',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_multipleFileTypeUploadError:::You can't upload files of type: " +
    p['fileTypes'] +
    ']]',
  filePicker_singleFileUploadError: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_singleFileUploadError:::Upload one file at a time]]',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_singleTypeUploadError:::You can't upload files of type " +
    p['fileType'] +
    ']]',
  filePicker_unknownFileTypeUploadError: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::filePicker_unknownFileTypeUploadError:::unknown]]',
  formControl_clear: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_clear:::Clear]]',
  formControl_day: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_day:::Day]]',
  formControl_empty_segment: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_empty_segment:::Empty]]',
  formControl_helpAvailable: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_helpAvailable:::Help available]]',
  formControl_hide: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_hide:::Hide]]',
  formControl_hour: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_hour:::Hour]]',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_limitReached:::You’ve reached the ' +
    ((
      {
        one: new Intl.NumberFormat('en-XC').format(p['CHARACTER_LIMIT']) + '-character'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('en-XC').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('en-XC').format(p['CHARACTER_LIMIT']) + '-character') +
    ' limit.]]',
  formControl_loading: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_loading:::Loading]]',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_maxLength:::You can enter up to ' +
    p['MAX_LENGTH'] +
    ' characters.]]',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_maxLengthExceeded:::Maximum length ' +
    p['MAX_LENGTH'] +
    ' exceeded.]]',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_maxLengthRemaining:::' +
    p['CHARACTER_COUNT'] +
    ' characters left.]]',
  formControl_millisecond: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_millisecond:::Millisecond]]',
  formControl_minute: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_minute:::Minute]]',
  formControl_month: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_month:::Month]]',
  formControl_readOnly: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_readOnly:::Read only]]',
  formControl_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_requiredMessageDetail:::Enter a value.]]',
  formControl_second: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_second:::Second]]',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_selectionExactMessageDetail:::Select ' +
    p['n'] +
    ' values.]]',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_selectionOverflowMessageDetail:::You’ve reached the ' +
    p['max'] +
    '-selection limit.]]',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_selectionRangeMessageDetail:::Select ' +
    p['min'] +
    ' to ' +
    p['max'] +
    ' values.]]',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_selectionUnderflowMessageDetail:::Select at least ' +
    p['min'] +
    ' values.]]',
  formControl_show: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_show:::Show]]',
  formControl_year: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::formControl_year:::Year]]',
  gantt_labelDate: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::gantt_labelDate:::Date]]',
  gantt_labelEnd: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::gantt_labelEnd:::End]]',
  gantt_labelLabel: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::gantt_labelLabel:::Label]]',
  gantt_labelRow: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::gantt_labelRow:::Row]]',
  gantt_labelStart: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::gantt_labelStart:::Start]]',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_disabledLabel:::' +
    p['SECTION'] +
    '. No matching section found.]]',
  indexer_keyboardInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_keyboardInstructionText:::Press enter to select value.]]',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_separatorLabel:::Between ' +
    p['FROM_SECTION'] +
    ' and ' +
    p['TO_SECTION'] +
    '.]]',
  indexer_touchInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::indexer_touchInstructionText:::Double tap and hold to enter gesture mode, then drag up or down to adjust value.]]',
  info: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::info:::Info]]',
  inputColor_selectColor: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputColor_selectColor:::Select a color]]',
  inputDateMask_date_cleared: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDateMask_date_cleared:::Date cleared]]',
  inputDateMask_dayPlaceholder: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDateMask_dayPlaceholder:::dd]]',
  inputDateMask_empty_segment: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDateMask_empty_segment:::Empty]]',
  inputDateMask_monthPlaceholder: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDateMask_monthPlaceholder:::mm]]',
  inputDateMask_yearPlaceholder: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDateMask_yearPlaceholder:::yyyy]]',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDatePicker_dateRangeOverflowMessageDetail:::Enter a date that's on or before " +
    p['max'] +
    '.]]',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDatePicker_dateRangeUnderflowMessageDetail:::Enter a date that's on or after " +
    p['min'] +
    '.]]',
  inputDatePicker_dateRestrictionMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDatePicker_dateRestrictionMessageDetail:::Enter an available date.]]',
  inputDatePicker_instruction: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDatePicker_instruction:::Press Tab to access the calendar.]]',
  inputDatePicker_selectDate: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputDatePicker_selectDate:::Select a date]]',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputMonthMask_dateRangeOverflowMessageDetail:::Enter a month and year that's on or before " +
    p['max'] +
    '.]]',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputMonthMask_dateRangeUnderflowMessageDetail:::Enter a month and year that's on or after " +
    p['min'] +
    '.]]',
  inputNumber_converterParseError: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputNumber_converterParseError:::Enter a number.]]',
  inputNumber_decrease: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputNumber_decrease:::Decrease]]',
  inputNumber_increase: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputNumber_increase:::Increase]]',
  inputPassword_hidden: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputPassword_hidden:::Password Hidden]]',
  inputPassword_hide: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputPassword_hide:::Hide Password]]',
  inputPassword_show: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputPassword_show:::Show Password]]',
  inputSensitiveText_hidden: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputSensitiveText_hidden:::Sensitive text hidden]]',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputTimeMask_timeRangeOverflowMessageDetail:::Enter a time that's " +
    p['max'] +
    ' or earlier.]]',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    "[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputTimeMask_timeRangeUnderflowMessageDetail:::Enter a time that's " +
    p['min'] +
    ' or later.]]',
  inputTimeMask_time_cleared: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::inputTimeMask_time_cleared:::Time cleared]]',
  labelNone: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::labelNone:::None]]',
  list_msgFetchCompleted: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::list_msgFetchCompleted:::Loaded]]',
  list_msgFetchingData: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::list_msgFetchingData:::Loading]]',
  list_suggestion: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::list_suggestion:::Suggestion]]',
  menu_stateLoading: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::menu_stateLoading:::Loading]]',
  messageToast_allMessagesClosed: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::messageToast_allMessagesClosed:::All toast messages are closed.]]',
  message_close: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_close:::Close]]',
  message_confirmation: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_confirmation:::Success]]',
  message_error: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_error:::Error]]',
  message_info: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_info:::Info]]',
  message_navigationFromMessagesRegion: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_navigationFromMessagesRegion:::Entering messages region. Press F6 to navigate.]]',
  message_navigationToMessagesRegion: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_navigationToMessagesRegion:::Messages region has new messages. Press F6 to navigate.]]',
  message_navigationToTouch: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_navigationToTouch:::Messages region has new messages.]]',
  message_warning: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::message_warning:::Warning]]',
  noData_message: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::noData_message:::No items to display]]',
  overflowItemLabel: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::overflowItemLabel:::More Tabs]]',
  plural_separator: () => ', ',
  popup_close_skipLink: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::popup_close_skipLink:::Double tap to close the open pop-up.]]',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::popup_liveRegion_F6_initial_focus_firstFocusable:::Entering pop-up. Press F6 to navigate between the pop-up and associated control.]]',
  popup_liveRegion_F6_initial_focus_none: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::popup_liveRegion_F6_initial_focus_none:::Pop-up opened. Press F6 to navigate between the pop-up and associated control.]]',
  progressIndeterminate: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::progressIndeterminate:::In Progress]]',
  radioButton_checked: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::radioButton_checked:::Radio button checked]]',
  radioButton_selected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::radioButton_selected:::Radio button selected]]',
  radioButton_unchecked: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::radioButton_unchecked:::Radio button not checked]]',
  radioButton_unselected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::radioButton_unselected:::Radio button not selected]]',
  radio_helpForRadio: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::radio_helpForRadio:::Help for radio button]]',
  radio_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::radio_requiredMessageDetail:::Select a value.]]',
  selectMultiple_apply: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_apply:::Apply]]',
  selectMultiple_back: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_back:::Back]]',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_highlightSelectedTagsInstructionText:::Use left and right arrow keys to highlight selected values.]]',
  selectMultiple_removeSelectedTagInstructionText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_removeSelectedTagInstructionText:::Press Backspace or Delete to remove the selected value.]]',
  selectMultiple_selectedValues: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_selectedValues:::Selected values]]',
  selectMultiple_showSelectedValues: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_showSelectedValues:::Show selected values only.]]',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectMultiple_valuesSelected:::' +
    p['VALUE_COUNT'] +
    ' values selected.]]',
  select_addToList: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_addToList:::Add to list]]',
  select_addToListAvailable: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_addToListAvailable:::Add to list available]]',
  select_closeDropdown: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_closeDropdown:::Press Escape to close.]]',
  select_moreSearchOptions: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_moreSearchOptions:::More search options]]',
  select_moreSearchOptionsAvailable: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_moreSearchOptionsAvailable:::More search options available]]',
  select_noMatchesFound: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_noMatchesFound:::No matches found.]]',
  select_oneMatchFound: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_oneMatchFound:::One match found]]',
  select_requiredMessageDetail: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_requiredMessageDetail:::Select a value.]]',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_sizeMatchesFound:::' +
    p['TOTAL_SIZE'] +
    ' matches found]]',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::select_sizeOrMoreMatchesFound:::' +
    p['TOTAL_SIZE'] +
    ' or more matches found]]',
  selectorAll_deselectAll: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectorAll_deselectAll:::Deselect all]]',
  selectorAll_selectAll: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selectorAll_selectAll:::Select all]]',
  selector_selected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selector_selected:::Checkbox checked]]',
  selector_unselected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::selector_unselected:::Checkbox not checked]]',
  sheet_close: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::sheet_close:::Close]]',
  switch_off: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::switch_off:::Off]]',
  switch_on: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::switch_on:::On]]',
  tabBarNavigationList_removeCueText: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::tabBarNavigationList_removeCueText:::Removable]]',
  tabBar_tabContainsErrors: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::tabBar_tabContainsErrors:::Contains errors]]',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::tabbar_accAnnounceRemovedKey:::Removed ' +
    p['itemKey'] +
    ']]',
  tabbar_labelContextMenu: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::tabbar_labelContextMenu:::has context menu]]',
  tabbar_labelMoveLeft: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::tabbar_labelMoveLeft:::Move Left]]',
  tabbar_labelMoveRight: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::tabbar_labelMoveRight:::Move Right]]',
  tabbar_labelRemove: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::tabbar_labelRemove:::Remove]]',
  timeComponent_tooltipZoomIn: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::timeComponent_tooltipZoomIn:::Zoom In]]',
  timeComponent_tooltipZoomOut: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::timeComponent_tooltipZoomOut:::Zoom Out]]',
  timeConverter_parseError: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::timeConverter_parseError:::Enter a complete time.]]',
  train_current: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_current:::Current]]',
  train_message_type: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_message_type:::Message Type]]',
  train_not_visited: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_not_visited:::Not visited]]',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_status:::Step ' +
    p['currentStep'] +
    ' out of ' +
    p['numberOfSteps'] +
    ']]',
  train_visited: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::train_visited:::Visited]]',
  userAssistance_learnMore: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::userAssistance_learnMore:::Learn more]]',
  userAssistance_required: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::userAssistance_required:::Required]]',
  vis_clearSelection: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_clearSelection:::Clear Selection]]',
  vis_drillable: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_drillable:::Drillable]]',
  vis_invalidData: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_invalidData:::Invalid data]]',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_labelCountWithTotal:::' +
    p['itemCount'] +
    ' out of ' +
    p['totalCount'] +
    ']]',
  vis_marqueeSelectTooltip: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_marqueeSelectTooltip:::Marquee select]]',
  vis_marqueeZoomTooltip: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_marqueeZoomTooltip:::Marquee zoom]]',
  vis_noData: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_noData:::No data to display]]',
  vis_panTooltip: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_panTooltip:::Pan]]',
  vis_stateCollapsed: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_stateCollapsed:::Collapsed]]',
  vis_stateExpanded: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_stateExpanded:::Expanded]]',
  vis_stateLoaded: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_stateLoaded:::Loaded]]',
  vis_stateLoading: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_stateLoading:::Loading]]',
  vis_stateSelected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_stateSelected:::Selected]]',
  vis_stateUnselected: () =>
    '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::vis_stateUnselected:::Unselected]]',
  warn: () => '[[jet/packages/oraclejet-preact/src/resources/icu/en/bundle.json:::warn:::Warning]]'
};
export default bundle;
